import { InputAdornment, Stack, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material'
import type { ShiftSplit } from '../api/generated/ShiftSplit'
import { formatDuration } from './time'

/** A split as typed: by duration or by number of shifts, the amount as entered. */
export type Slicing = { by: 'minutes' | 'parts'; amount: string }

export const toSplit = ({ by, amount }: Slicing): ShiftSplit =>
  by === 'minutes' ? { minutes: Number(amount) } : { parts: Number(amount) }

/** Chooses cutting by duration or by number of shifts, and how much. */
export function SlicingField({
  value,
  partsLabel,
  onChange,
}: {
  value: Slicing
  /** Label of the number of shifts, `Nombre de créneaux` by default. */
  partsLabel?: string
  onChange: (value: Slicing) => void
}) {
  const minutes = Number(value.amount)
  return (
    <Stack spacing={1.5}>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={value.by}
        onChange={(_, by: Slicing['by'] | null) =>
          by && onChange({ by, amount: by === 'minutes' ? '120' : '2' })
        }
      >
        <ToggleButton value="minutes">Par durée</ToggleButton>
        <ToggleButton value="parts">Par nombre</ToggleButton>
      </ToggleButtonGroup>
      {value.by === 'minutes' ? (
        <TextField
          label="Durée de chaque créneau"
          type="number"
          required
          slotProps={{
            htmlInput: { min: 1 },
            input: { endAdornment: <InputAdornment position="end">min</InputAdornment> },
          }}
          helperText={minutes > 0 && formatDuration(minutes)}
          value={value.amount}
          onInput={(e) => onChange({ ...value, amount: (e.target as HTMLInputElement).value })}
        />
      ) : (
        <TextField
          label={partsLabel ?? 'Nombre de créneaux'}
          type="number"
          required
          slotProps={{ htmlInput: { min: 1 } }}
          value={value.amount}
          onInput={(e) => onChange({ ...value, amount: (e.target as HTMLInputElement).value })}
        />
      )}
    </Stack>
  )
}
